import React from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <input
    type="text"
    value={value}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
    autoComplete="off"
    style={{ padding: 8, minWidth: 180, borderRadius: 6, border: '1px solid #ccc' }}
  />
);

export default SearchBar; 